import script from "./LicenseCreateUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./LicenseCreateUpdate.vue?vue&type=script&setup=true&lang=js"

import "./LicenseCreateUpdate.vue?vue&type=style&index=0&id=0de5045e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0de5045e"]])

export default __exports__